export default {
  'en': {
    'facts': [
      'The year it began',
      'Billion SMS messages',
      'Countries'
    ]
  },
  'da': {
    'facts': [
      'Året hvor det begyndte',
      'Milliarder SMS beskeder',
      'Lande'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/multilanguage/facts.js